




























































































import Vue from 'vue';
import { NumberEntry } from '@/components/number-entry-component';
import { StepperWrapper } from '@/components/stepper-wrapper-component';
import {
  OpenHelp,
  RouteTracking,
  FormValidation,
  CloseStepperWrapper,
} from '@/mixins';
import { openAddBankAccountScreen } from '@/mixins/get-content-mixins/bank-account-add.mixin';
import store from '@/store';
import { ExtendMixins, LoadingService } from '@/services';
import ReviewDepositForm from '@/components/account-tools/make-deposit-components/review-deposit-form.component.vue';
import { EventBus } from '@/event-bus/event-bus';
import { getContentArea } from '@/contentful';
import { api, ACCOUNT_API_SUB_URLS } from '@/api';
import { StepperSteps } from '@/@types/member';

interface Data {
  amount: string;
  isOneTime: boolean;
  confirmBeforeClose: boolean;
  changeMade: boolean;
  submitIsLoading: boolean;
  showSubmitSuccessMessage: boolean;
  successMessage: string;
  showSubmitErrorMessage: boolean;
  errorMessage: string;
  showWrapper: boolean;
  currentStep: number;
  showTaxYearNote: boolean;
  taxYearNote: string;
}

export default ExtendMixins(
  OpenHelp,
  RouteTracking,
  CloseStepperWrapper,
  FormValidation,
).extend({
  name: 'MakeDeposit',
  beforeRouteEnter(to, from, next) {
    const promises = [
      store.dispatch('getAccounts'),
      store.dispatch('getBankingInformation'),
      store.dispatch('getIRSContributionLimits'),
      store.dispatch('getPersonalInformation'),
      getContentArea([
        'make-deposit-success',
        'make-deposit-error',
        'make-a-deposit-tax-year-note-on-off-switch',
        'make-deposit-tax-year-note',
      ]),
      store.dispatch('getMemberCustomerServiceInformation'),
      store.dispatch('getGroupMigrationDates', store.getters.user.groupKey),
    ];
    api
      .get(`${ACCOUNT_API_SUB_URLS.scheduledDeposits}`, {
          params: {
            memberId: store.getters.user.memberId,
          },
      })
      .then((response) => {
        const hasRecurring = response.data.find((item) => {
          return !item.isOneTime;
        });

        to.meta.hideTypeSelection = !!hasRecurring;
        loadPromises();
      })
      .catch((error) => {
        if (error.status === 500) {
          EventBus.$emit('openModal', 'Error', {
            message: 'global_connection-error',
            action: {
              label: 'global_try-again',
              performAction() {
                location.reload();
              },
            },
            hideCancel: true,
          });
          EventBus.$emit('initialLoadDone');
        } else {
          to.meta.hideTypeSelection = false;
          loadPromises();
        }
      });

    function loadPromises() {
      LoadingService.watchPromises(promises)
        .then((data) => {
          const bankingInformation = data[1],
            contentAreas = data[4];
          if (
            bankingInformation &&
            bankingInformation.length &&
            store.getters.hasActiveHSA &&
            store.getters.bankAccountsForDeposit.length
          ) {
            if (contentAreas) {
              if (contentAreas[0] && contentAreas[0].fields) {
                to.meta.successMessage = contentAreas[0].fields.content;
              }
              if (contentAreas[1] && contentAreas[1].fields) {
                to.meta.errorMessage = contentAreas[1].fields.content;
              }
              if (contentAreas[2] && contentAreas[2].fields) {
                to.meta.showTaxYearNote = contentAreas[2].fields.showhide;
              }
              if (contentAreas[3] && contentAreas[3].fields) {
                to.meta.taxYearNote = contentAreas[3].fields.content;
              }
            }

            next();
          } else if (!store.getters.hasActiveHSA) {
            EventBus.$emit('openModal', 'Error', {
              title: 'make-deposit_error-no-hsa-heading',
              message: 'make-deposit_error-no-hsa-message',
            });
            EventBus.$emit('initialLoadDone');
            next({ name: 'accounts' });
          } else {
            EventBus.$emit('openModal', 'Error', {
              title: 'make-deposit_error-no-bank-heading',
              message: 'make-deposit_error-no-bank-message',
              tokenAction: {
                label: 'make-deposit_error-no-bank-action-label',
              },
              tokenCallback: () => {
                openAddBankAccountScreen({
                  routeAfterClose: { name: 'makeDeposit', params: { step: 1 } },
                });
              },
            });
            EventBus.$emit('initialLoadDone');
            next({ name: 'accounts' });
          }
        })
        .catch(() => {
          EventBus.$emit('openModal', 'Error', {
            message: 'global_connection-error',
            action: {
              label: 'global_try-again',
              performAction() {
                location.reload();
              },
            },
            hideCancel: true,
          });
          EventBus.$emit('initialLoadDone');
        });
    }
  },
  data(): Data {
    return {
      amount: '0.0',
      isOneTime: true,
      confirmBeforeClose: true,
      changeMade: false,
      submitIsLoading: false,
      showSubmitSuccessMessage: false,
      successMessage: this.$route.meta.successMessage,
      showSubmitErrorMessage: false,
      errorMessage: this.$route.meta.errorMessage,
      showTaxYearNote: this.$route.meta.showTaxYearNote,
      taxYearNote: this.$route.meta.taxYearNote ? this.$route.meta.taxYearNote : '',
      showWrapper: true,
      currentStep: 1,
    };
  },
  computed: {
    stepsMap(): any {
      return this.steps.reduce((map, obj) => {
        map[obj.ref] = obj;
        return map;
      }, {});
    },
    steps(): StepperSteps[] {
      let steps = [
        {
          ref: 'selectType',
          name: 'make-deposit_step_select-type',
          showBack: false,
          isCompleted: false,
          isEditable: false,
        },
        {
          ref: 'howMuch',
          name: 'make-deposit_step_how-much',
          showBack: false,
          isCompleted: false,
          isEditable: false,
        },
        {
          ref: 'review',
          name: 'make-deposit_step_review',
          showBack: true,
          isCompleted: false,
          isEditable: false,
        },
      ];

      if (this.$route.meta.hideTypeSelection) {
        steps.shift();
      }

      steps = steps.map((step, index) => {
        const newStep: StepperSteps = {} as StepperSteps;
        if (index === 0) {
          newStep.showBack = false;
        }
        newStep.stepPosition = (index + 1).toString();
        return Object.assign(step, newStep);
      });

      return steps;
    },
    groupTollFreePhone(): string {
      return this.$store.getters.groupTollFreePhone;
    },
  },
  methods: {
    updateConfirmBeforeClose(val): void {
      this.confirmBeforeClose = val;
    },
    toggleLoading(val): void {
      this.submitIsLoading = val;
    },
    hideWrapper(): void {
      this.showWrapper = false;
    },
    setNumber(value): void {
      this.amount = parseFloat(value).toFixed(2);
    },
    nextStep(): void {
      this.changeMade = true;
      if (parseInt(this.currentStep.toString()) < this.steps.length) {
        this.steps[this.currentStep - 1].isCompleted = true;
        this.currentStep++;
      }
    },
    setStep(step): void {
      this.currentStep = step;
    },
    setDepositType(type): void {
      this.isOneTime = type;
      this.nextStep();
    },
    submitDeposit(): void {
      this.submitIsLoading = true;
    },
  },
  components: {
    StepperWrapper,
    NumberEntry,
    ReviewDepositForm,
  },
});
